<template>
	<mobile v-if="mobile" :id="id"></mobile>
	<pc v-else :id="id"></pc>
</template>

<script>
	import pc from './person_change_detail_pc.vue'
	import mobile from './person_change_detail_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'person_change_detail',
		
		components: {
			pc,
			mobile
		},
		
		props: {
			id: String
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>